/* ────────────────────────────────────────────────────────────────
   RS Form Validate — shared, surface-agnostic client validator

   Generalized from the inline validator that used to live in
   sections/rs-contact-hero.liquid. Attribute-driven: contains NO
   surface-specific ids or class names. Any {% form %} opts in with
   data-rs-validate and the data-hook contract below.

   ── Data-hook contract ──────────────────────────────────────────
     form[data-rs-validate]        opt-in marker on the <form>
     [data-rs-field]               field wrapper — carries .is-invalid
     [data-rs-error-text]          the message text node inside a sink
     [data-rs-form-success]        present when a server-rendered
                                   success state exists → strips the
                                   ?…_posted=true query on load

   ── Conventions ─────────────────────────────────────────────────
     • Validated fields are auto-discovered: every [required] input,
       select, or textarea inside the form, EXCLUDING type="hidden".
       Non-required controls (honeypot, optional fields, disabled
       reassurance inputs) are never collected.
     • Each validated input MUST have an id. Its error sink is located
       by the <inputId>-error convention.
     • Per-field copy lives in data-error-required / data-error-type
       on the input.

   ── Captcha defense (load-bearing) ──────────────────────────────
     Shopify injects a document-level submit listener that, on
     hcaptcha-bound forms, resubmits via a programmatic form.submit()
     which fires NO submit event — so preventDefault() alone is
     bypassed. stopImmediatePropagation() on the invalid branch halts
     the event before it reaches that document-level shim. This
     handler runs first (AT_TARGET on the form), so it wins. Do not
     remove or reorder it. Only reproduces on a real domain.
   ──────────────────────────────────────────────────────────────── */
(function () {
  if (window.rsFormValidateLoaded) return;
  window.rsFormValidateLoaded = true;

  function validateField(input) {
    if (!input) return true;
    var sink = document.getElementById(input.id + '-error');
    var wrapper = input.closest('[data-rs-field]');
    var v = input.validity;
    var message = null;
    if (v.valueMissing) {
      message = input.dataset.errorRequired || 'This field is required.';
    } else if (v.typeMismatch) {
      message = input.dataset.errorType || 'Please enter a valid value.';
    }
    if (message) {
      if (sink) {
        var textEl = sink.querySelector('[data-rs-error-text]');
        if (textEl) textEl.textContent = message;
        sink.removeAttribute('hidden');
      }
      if (wrapper) wrapper.classList.add('is-invalid');
      input.setAttribute('aria-invalid', 'true');
      input.setAttribute('aria-describedby', input.id + '-error');
      return false;
    }
    if (sink) {
      var textEl2 = sink.querySelector('[data-rs-error-text]');
      if (textEl2) textEl2.textContent = '';
      sink.setAttribute('hidden', '');
    }
    if (wrapper) wrapper.classList.remove('is-invalid');
    input.removeAttribute('aria-invalid');
    input.removeAttribute('aria-describedby');
    return true;
  }

  function bindForm(form) {
    if (form.dataset.rsValidateBound === '1') return;
    form.dataset.rsValidateBound = '1';

    var fields = Array.prototype.slice
      .call(form.querySelectorAll('input[required], select[required], textarea[required]'))
      .filter(function (el) { return el.type !== 'hidden'; });

    var submitAttempted = false;

    form.addEventListener('submit', function (event) {
      submitAttempted = true;
      var allValid = true;
      var firstInvalid = null;
      fields.forEach(function (input) {
        var ok = validateField(input);
        if (!ok && !firstInvalid) firstInvalid = input;
        if (!ok) allValid = false;
      });
      if (!allValid) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (firstInvalid) firstInvalid.focus();
      }
    });

    fields.forEach(function (input) {
      input.addEventListener('input', function () {
        if (submitAttempted) validateField(input);
      });
    });
  }

  function init() {
    if (document.querySelector('[data-rs-form-success]')) {
      history.replaceState(null, '', window.location.pathname);
    }
    var forms = document.querySelectorAll('form[data-rs-validate]');
    Array.prototype.forEach.call(forms, bindForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
